import { getCurrentLanguage } from "utils/getCurrentLanguage";

interface InputProps {
  [key: string]: string;
}
export const getDataBasedOnLang = (Obj: InputProps) => {
  const currentLanguage = getCurrentLanguage();
  return Obj[currentLanguage] || Obj["en"];
};
